<script>
import {Carousel, Slide} from "vue-carousel";
import Layout from "@/pages/congdan/layout";
// import the component
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapState} from "vuex";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import moment from 'moment-timezone';
import Map from '@/components/Map.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Map,
    
  },
  data() {
    return {
      apiView: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      url: `${process.env.VUE_APP_API_URL}filesminio/view`,
      ImagesShow: [],
      totalRows: 1,
      totalRowsDl: 1,
      totalRowsSen: 1,
      totalRowsMonAn: 1,
      numberOfElement: 1,
      perPage: 5,
      perPageDl: 5,
      perPageSen: 3,
      perPageMonAn: 5,
      perPageAll: 2,
      perPageOne: 1,
      perPageSPS: 3,
      currentPage: 1,
      currentPageDl: 1,
      currentPageSen: 1,
      currentPageMonAn: 1,
      sortDesc: false,
      showModal: true,
      checked: false,
      submitted: false,
      currentPlace: null,
      showCurrentPlace: true,
      selection: "all",
      visible: false,
      listFileSilder : [],
      selectedItem: null,
      locale: 'vi',
      // NEW
      pagendslider: 1,
      dulichsen: [],
      sanphamsen: [],
      doanhnghiep: [],
      sen: [],
      monansen: [],
      tinnoibat: [],
      slide: 0,
      sliding: null,
      ratings: 5,
      settings: {
        "arrows": false,
        "dots": false,
        "infinite": false,
        "autoplay": true,
        "autoplaySpeed": 3000,
        "cssEase": "linear",
        "speed": 1000,
        "slidesToShow": 3,
        "slidesToScroll": 1,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 1,
              "infinite": true,
              "dots": false
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 1,
              "initialSlide": 4,
              "dots": false
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "dots": false
            }
          }
        ]
      },
    };
  },

  computed: {
    ...mapState('authStore', ['token']),
    filteredDoanhnghiep() {
        return this.doanhnghiep.filter(item => item.avartar && item.sdt && item.diaChi);
    }

    //Validations
  },
  validations() {
    return {
      model: this.rules
    }
  },
  created() {

    const user = {
      id: 1,
      name: 'Victory Osayi',
      is_editor: true,
      is_admin: false,
      // you can have role based permission list or access control list possibly from database
      permissions: ['admin', 'owner', 'moderator', 'create-post', 'edit-post', 'delete-post']
    }
    // NEW
    this.getDuLichSen();
    this.getSanPhamSen();
    this.getDoanhNghiep();
    this.getSen();
    this.getMonAnSen();
    this.getTinNoiBat();
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },

  mounted() {
    window.addEventListener('resize', this.updatePerPage);
    // Initial call to set the initial value
    this.updatePerPage();
  },

  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updatePerPage);
  },
  watch: {
    token: {
      deep: true,
      handler(val) {
        this.tokenCurrent = val;
      }
    },
    perPage: {
      deep: true,
      handler(val){
        this.getSanPhamSen();
      }
    },
    currentPage:{
      deep: true,
      handler(val){
        this.getSanPhamSen();
      }
    },
    perPageDl: {
      deep: true,
      handler(val){
        this.getDuLichSen();
      }
    },
    currentPageDl:{
      deep: true,
      handler(val){
        this.getDuLichSen();
      }
    },
    perPageSen: {
      deep: true,
      handler(val){
        this.getSen();
      }
    },
    currentPageSen:{
      deep: true,
      handler(val){
        this.getSen();
      }
    },
    perPageMonAn: {
      deep: true,
      handler(val){
        this.getMonAnSen();
      }
    },
    currentPageMonAn:{
      deep: true,
      handler(val){
        this.getMonAnSen();
      }
    }
  },

  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },

    updatePerPage() {
      // Update perPage based on window width
      if (window.innerWidth < 450) {
        this.perPageSPS = 1;
        this.pagend = 1;
        this.perPageOne = 1
      }
      else if (window.innerWidth < 576) {
        this.pagend = 2;
        this.perPageOne = 1
      }
      else if (window.innerWidth < 768) {
        this.perPageSPS = 1; // For small screens, show 1 item per page
        this.perPageOne = 1
        this.perPageSen = 2
      } else if (window.innerWidth < 1024) {
        this.perPageSPS = 2; // For medium screens, show 2 items per page
        this.perPageOne = 1
        this.perPageSen = 2
      } else {
        this.perPageSPS = 3;
        this.perPageOne = 1
        this.perPageSen = 3
      }
    },
    async getSen(){
      const params = {
        start: this.currentPageSen,
        limit: this.perPageSen,
        sortDesc: true,
        sortBy: "thuTu",
      }
      await this.$store.dispatch("senStore/getPagingParams", params).then((res) => {
        this.sen = res.data.data;
        this.totalRowsSen = res.data.totalRows
      })
    },

    async getDuLichSen(){
      const params = {
        start: this.currentPageDl,
        limit: this.perPageDl,
        sortDesc: true,
        sortBy: "thuTu",
      }
      await this.$store.dispatch("duLichSenStore/getPagingParams", params).then((res) => {
        this.dulichsen = res.data.data;
        this.totalRowsDl = res.data.totalRows
      })
    },
    async getSanPhamSen(){
      const params = {
        start: this.currentPage,
        limit: this.perPage,
        sortDesc: true,
        sortBy: "danhGia",
      }
      await this.$store.dispatch("sanPhamSenStore/getPagingParams", params).then((res) => {
        this.sanphamsen = res.data.data;
        this.totalRows = res.data.totalRows
      })
    },
    async getDoanhNghiep(){
      const params = {
        start: 0,
        limit: 99,
        sortBy: "thuTu",
        sortDesc: true,
      }
      await this.$store.dispatch("doanhNghiepStore/getPagingParams", params).then((res) => {
        this.doanhnghiep = res.data.data;
      })
    },
    async getMonAnSen(){
      const params = {
        start: this.currentPageMonAn,
        limit: this.perPageMonAn,
        sortDesc: true,
        sortBy: "thuTu",
      }
      await this.$store.dispatch("monAnSenStore/getPagingParams", params).then((res) => {
        this.monansen = res.data.data;
        this.totalRowsMonAn = res.data.totalRows
      })
    },

    async getTinNoiBat(){
      const params = {
        start: this.currentPage,
        limit: this.perPage,
        sortDesc: true,
        sortBy: "thuTu",
      }
      await this.$store.dispatch("tinnoibatStore/getPagingParams", params).then((res) => {
        this.tinnoibat = res.data.data;
        this.totalRows = res.data.totalRows
      })
    },
    // async getThongTinSlider(){
    //   let promise =  this.$store.dispatch("sliderStore/getAll")
    //   return promise.then(resp => {
    //     if(resp.data == null){
    //       return []
    //     }else{
    //       if (resp.data != null )
    //       {
    //         this.listFileSilder = []
    //         this.listFileSilder = resp.data;
    //       }
    //     }
    //   })
    // },

    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    nextSlide1() {
      this.$refs.carousel1.goToPage(this.$refs.carousel1.getNextPage());
      this.$refs.carousel2.goToPage(this.$refs.carousel2.getNextPage());
    },
    prevSlide1() {
      this.$refs.carousel1.goToPage(this.$refs.carousel1.getPreviousPage());
      this.$refs.carousel2.goToPage(this.$refs.carousel2.getPreviousPage());
    },
    nextSlide3() {
      this.$refs.carousel3.goToPage(this.$refs.carousel3.getNextPage());
    },
    prevSlide3() {
      this.$refs.carousel3.goToPage(this.$refs.carousel3.getPreviousPage());
    },
    nextSlide4() {
      this.$refs.carouselsps.goToPage(this.$refs.carouselsps.getNextPage());
      this.$refs.carouselspsn.goToPage(this.$refs.carouselspsn.getNextPage());
      this.$refs.carouselspsone.goToPage(this.$refs.carouselspsone.getNextPage());
    },
    prevSlide4() {
      this.$refs.carouselsps.goToPage(this.$refs.carouselsps.getPreviousPage());
      this.$refs.carouselspsn.goToPage(this.$refs.carouselspsn.getPreviousPage());
      this.$refs.carouselspsone.goToPage(this.$refs.carouselspsone.getPreviousPage());
    },
    nextSlidemas() {
      this.$refs.carouselmas.goToPage(this.$refs.carouselmas.getNextPage());
      this.$refs.carouselmas1.goToPage(this.$refs.carouselmas1.getNextPage());
    },
    prevSlidemas() {
      this.$refs.carouselmas.goToPage(this.$refs.carouselmas.getPreviousPage());
      this.$refs.carouselmas1.goToPage(this.$refs.carouselmas1.getPreviousPage());
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleSelectChange() {
      if (this.selectedItem) {
        this.getId(this.selectedItem);
      }
    },
    getId(id){
      this.relink.push(process.env.VUE_APP_API_URL + 'filesminio/view/' + id)
      this.showPreview();
    },
    showPreview() {
      const preview = this.$imagePreview({
        initIndex: 0,
        images:this.relink,
        isEnableBlurBackground: false,
        isEnableLoopToggle: true,
        initViewMode: "contain",
        containScale: 1,
        shirnkAndEnlargeDeltaRatio: 0.2,
        wheelScrollDeltaRatio: 0.2,
        isEnableImagePageIndicator: true,
        maskBackgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 4000,
        isEnableDownloadImage: true
      })
      this.relink=[]
    },
    openNewTab(event) {
      const selectedValue = event.target.value;
      if (selectedValue !== "") {
        window.open(selectedValue, '_blank');
      }
    },
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    dateDisabled(ymd, date) {
        // Disable weekends (Sunday = `0`, Saturday = `6`) and
        // disable days that fall on the 13th of the month
        const weekday = date.getDay()
        const day = date.getDate()
        // Return `true` if the date should be disabled
        return weekday !== 1 
      }
  },
};
</script>
<template>
  <Layout>
    <section class="section pt-0">
      <div class="bg-main" style="margin-top: 47px;">
        <div class="container" style="padding: 0 50px;">
          <b-row>
            <div class="col-md-12 mt-3 card-map">
              <Map></Map>
            </div>

            <div class="food-lotus mt-3">
              <div class="row">
                <div class="col-md-12 fs-18 font-weight-bold title">
                  <router-link
                      :to="{
                          path: `/tin-noi-bat`,
                          }"
                  >
                    <div class="icon-star color fs-15 name">
                      <i class="mdi mdi-star ic-item"></i>
                      <span style="margin-left: 5px;" class="name-text">TIN TỨC NỔI BẬT</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-6 card-new-left mt-2 mb-2" v-for="(item, index) in tinnoibat.filter((item, index) => index == 0)" :key="index">
                  <router-link
                      :to="{
                          path: `/tin-noi-bat/chi-tiet/${item._id}`,
                          }"
                  >
                    <div class="card-new">
                      <div class="img-new">
                        <img v-if ="item.avartar"
                          :src="apiView + item.avartar.fileId"
                          style="height: 100%;"
                          loading="lazy"
                        />
                      </div>
                      <p class="card-new-name mt-2">
                        {{ item.name }}
                      </p>
                      <p class="card-new-name-sub mt-1">
                          {{ item.moTa }}
                      </p>
                      <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
                        <b-button
                          pill
                          class="fs-13 btn-detail"
                          size=""
                        >
                          <i class='bx bx-link-external ps-2'></i>
                            <span class="ps-1 px-2">Chi tiết</span>
                            <!-- <i class="mdi mdi-arrow-right ps-2"></i> -->
                        </b-button>
                      </div>
                      
                    </div>
                  </router-link>
                </div>

                <div class="col-md-6 mt-2">
                  <div class="row">
                    <div class="col-md-12 mb-3" v-for="(item, index) in tinnoibat.filter((item, index) => index !== 0)" :key="index.id">
                      <router-link
                          :to="{
                              path: `/tin-noi-bat/chi-tiet/${item._id}`,
                              }"
                      >
                        <div class="row">
                          <div class="col-md-4 col-sm-4" style="display: flex;align-items: center;">
                            <div class="img-new-right">
                              <img v-if ="item.avartar"
                                :src="apiView + item.avartar.fileId"
                                style="height: 100%;"
                                loading="lazy"
                              />
                            </div>
                          </div>
                          <div class="col-md-8 col-sm-8" style="display: flex; align-items: center;">
                            <div>
                              <h5 class="card-new-name-title">
                                {{ item.name }}
                              </h5>
                              <p class="card-new-name-sub">
                                {{ item.moTa }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="food-lotus mt-3">
              <div class="row">
                <div class="col-md-12 fs-18 font-weight-bold title">
                  <router-link
                      :to="{
                          path: `/san-pham-sen`,
                          }"
                  >
                    <div class="icon-star color fs-15 name">
                      <i class="mdi mdi-star ic-item"></i>
                      <span style="margin-left: 5px;" class="name-text">SẢN PHẨM TỪ SEN</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-6 img-food mt-2 mb-2" v-for="(item, index) in sanphamsen.filter((item, index) => index == 0)" :key="index">
                  <router-link
                      :to="{
                          path: `/san-pham-sen/chi-tiet/${item._id}`,
                          }"
                  >
                    <div>
                      <div class="img-food-sub">
                        <img v-if ="item.avartar"
                          :src="apiView + item.avartar.fileId"
                          class=""
                          style="height: 100%;"
                          loading="lazy"
                        />
                        <div style="
                          display: flex; 
                          align-items: center; 
                          font-size: 18px; 
                          position: absolute;
                          bottom: 0;
                          background-color: #d83f7d;
                          border-bottom-left-radius: 10px;
                          border-top-right-radius: 10px;
                        ">
                          <div class="rating">
                            <span v-for="rating in item.danhGia" :key="rating" :class="{ 'filled': rating <= item.danhGia }">&#9733;</span>
                          </div>
                        </div>
                      </div>
                      <p class="card-name">
                        {{ item.name }}
                      </p>
                      <p class="card-name-sub">
                          {{ item.mieuTa }}
                      </p>
                      
                    </div>
                  </router-link>
                </div>
                <div class="col-md-6 mt-2" style="position: relative;">
                  <div class="row">
                    <div class="col-md-6 col-sm-6" v-for="(item, index) in sanphamsen.filter((item, index) => index !== 0)" :key="index.id">
                      <router-link
                          :to="{
                              path: `/san-pham-sen/chi-tiet/${item._id}`,
                              }"
                      >
                        <div>
                          <div class="img-food-sub">
                            <img v-if ="item.avartar"
                              :src="apiView + item.avartar.fileId"
                              class=""
                              style="height: 100%;"
                              loading="lazy"
                            />
                            <div style="
                              display: flex; 
                              align-items: center; 
                              font-size: 18px; 
                              position: absolute;
                              bottom: 0;
                              background-color: #d83f7d;
                              border-bottom-left-radius: 10px;
                              border-top-right-radius: 10px;
                            ">
                              <div class="rating">
                                <span v-for="rating in item.danhGia" :key="rating" :class="{ 'filled': rating <= item.danhGia }">&#9733;</span>
                              </div>
                            </div>
                          </div>
                          <p class="card-name">
                            {{ item.name }}
                          </p>
                          <p class="card-name-sub">
                              {{ item.mieuTa }}
                          </p>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-pagination">
                  <div class="dataTables_paginate">
                    <ul class="pagination pagination-rounded mb-0" id="pagination-sps">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="food-lotus mt-3">
              <div class="row">
                <div class="col-md-12 fs-18 font-weight-bold title">
                  <router-link
                      :to="{
                          path: `/du-lich-sen`,
                          }"
                  >
                    <div class="icon-star color fs-15 name">
                      <i class="mdi mdi-star ic-item"></i>
                      <span style="margin-left: 5px;" class="name-text">ĐIỂM DU LỊCH SEN</span>
                    </div>
                  </router-link>
                </div>
                <div v-for="(item, index) in dulichsen.filter((item, index) => index == 0)" :key="index" 
                    class="col-md-6 col-sm-6 img-dl mt-2 mb-2"
                >
                <router-link
                    :to="{
                        path: `/du-lich-sen/chi-tiet/${item._id}`,
                        }"
                >
                  <div>
                    <img v-if ="item.avartar"
                        :src="apiView + item.avartar.fileId"
                        class=""
                        style="height: 100%;"
                        loading="lazy"
                    />
                    <p class="card-name-dl">
                      {{ item.name }}
                    </p>
                    
                  </div>
                </router-link>
                </div>
                <div class="col-md-6 col-sm-6" style="position: relative;">
                  <div class="row">
                    <div class="col-md-6 col-sm-6 mt-2" v-for="(item, index) in dulichsen.filter((item, index) => index !== 0)" :key="index.id">
                      <router-link
                            :to="{
                                path: `/du-lich-sen/chi-tiet/${item._id}`,
                                }"
                        >
                          <div class="img-food-sub" style="position: relative;">
                                <img v-if ="item.avartar"
                                  :src="apiView + item.avartar.fileId"
                                  class=""
                                  style="height: 100%;"
                                  loading="lazy"
                              />
                            <p class="card-name-dl-sub">
                              {{ item.name }}
                            </p>
                          </div>
                        </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-pagination">
                  <div class="dataTables_paginate">
                    <ul class="pagination pagination-rounded mb-0" id="pagination-dl">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPageDl"
                          :total-rows="totalRowsDl"
                          :per-page="perPageDl"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="hoatdong mt-3">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="content-slick">
                    <div style="padding: 0px 12px;">
                      <div class="col-md-12 fs-18 font-weight-bold title">
                        <router-link
                            :to="{
                                path: `/sen`,
                                }"
                        >
                          <div class="icon-star color fs-15 name">
                            <i class="mdi mdi-star ic-item"></i>
                            <span style="margin-left: 5px;" class="name-text">GIỐNG SEN</span>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6" v-for="(item, index) in this.sen" :key="index" style="position: relative;">
                  <router-link
                      :to="{
                          path: `/sen/chi-tiet/${item._id}`,
                          }"
                  >
                    <div class="card-img">
                      <div style="height: 100%;">
                        <img v-if ="item.avartar"
                          :src="apiView + item.avartar.fileId"
                          class=""
                          style="height: 100%;"
                          loading="lazy"
                      />

                      </div>
                    </div>
                    <img
                        :src="apiView + item.qrCode?.fileId"
                        class=""
                        style="
                          position: absolute;
                          right: 22px; 
                          top: 10px; 
                          width: 80px; 
                          height: 80px;
                          border-radius: 10px;
                          opacity: 0.8;"
                    >
                    <div class="box-text">
                      <div class="box-info" style="height: auto !important;">
                        <p class="card-name-sen">
                          {{ item.name }}
                        </p>
                        <p class="decs-cate-sen mt-2">
                          {{ item.moTa }}
                        </p>
                        <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                          <div class="view">
                            <i class="mdi mdi-eye" style="margin-right: 5px;"></i>
                            {{ item.view }}
                          </div>
                          <b-button
                            pill
                            class="fs-13 btn-detail"
                            size=""
                            >
                            <i class='bx bx-link-external ps-2'></i>
                              <span class="ps-1 px-2">Chi tiết</span>
                              <!-- <i class="mdi mdi-arrow-right ps-2"></i> -->
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </router-link>
                  <div v-for ="(items,index) in item.menu" :key="index" class="card-sub-name bg-menu">
                    <span v-if="index === 0">{{ items.name }}</span>
                  </div>
                </div>
                <div class="col-sen">
                  <div class="dataTables_paginate">
                    <ul class="pagination pagination-rounded mb-0" id="pagination-sen">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPageSen"
                          :total-rows="totalRowsSen"
                          :per-page="perPageSen"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="food-lotus mt-3">
              <div class="row">
                <div class="col-md-12 fs-18 font-weight-bold title">
                  <router-link
                      :to="{
                          path: `/mon-an-sen`,
                          }"
                  >
                    <div class="icon-star color fs-15 name">
                      <i class="mdi mdi-star ic-item"></i>
                      <span style="margin-left: 5px;" class="name-text">MÓN ĂN TỪ SEN</span>
                    </div>
                  </router-link>
                </div>
                <div v-for="(item, index) in monansen.filter((item, index) => index == 0)" :key="index" 
                    class="col-md-6 col-sm-12 img-food mt-2 mb-2"
                >
                  <router-link
                      :to="{
                          path: `/mon-an-sen/chi-tiet/${item._id}`,
                          }"
                  >
                    <div>
                      <img v-if ="item.avartar"
                          :src="apiView + item.avartar.fileId"
                          class=""
                          style="height: 100%;"
                          loading="lazy"
                      />
                      <p class="card-name">
                        {{ item.name }}
                      </p>
                      
                    </div>
                  </router-link>
                </div>
                <div class="col-md-6 mt-2" style="position: relative;">
                  <div class="row">
                    <div class="col-md-6 col-sm-6" v-for="(item, index) in monansen.filter((item, index) => index !== 0)" :key="index.id">
                      <router-link
                          :to="{
                              path: `/mon-an-sen/chi-tiet/${item._id}`,
                              }"
                      >
                        <div class="img-food-sub" >
                              <img v-if ="item.avartar"
                                :src="apiView + item.avartar.fileId"
                                class=""
                                style="height: 100%;"
                                loading="lazy"
                            />
                          <p class="card-name">
                            {{ item.name }}
                          </p>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-pagination">
                  <div class="dataTables_paginate">
                    <ul class="pagination pagination-rounded mb-0" id="pagination-monan">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPageMonAn"
                          :total-rows="totalRowsMonAn"
                          :per-page="perPageMonAn"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
  
          <div class="wrap-one mt-2">
            <div class="row">
              <div class="col-md-12 fs-18 font-weight-bold title">
                <div class="icon-star color fs-15 name">
                  <i class="mdi mdi-star ic-item"></i>
                  <span style="margin-left: 5px;" class="name-text">DOANH NGHIỆP</span>
                </div>
              </div>
              <carousel ref="" :per-page="perPageSPS" class="mt-3">
                <slide v-for="(item, index) in filteredDoanhnghiep" :key="index">
                  <div class="card-doanhnghiep">
                    <div class="row">
                      <div class="col-md-4 col-sm-4 bg-left">
                        <img v-if ="item.avartar"
                            :src="apiView + item.avartar.fileId"
                            class=""
                            loading="lazy"
                        />
                      </div>
                      <div class="col-md-8 col-sm-8 bg-right">
                        <p class="card-doanhnghiep-name">
                          {{ item.name }}
                        </p>
                        <p class="card-doanhnghiep-daidien">
                          {{ item.nguoiDaiDien }}
                        </p>
                        <span>
                          NGƯỜI ĐẠI DIỆN
                        </span>
                      </div>
                      <div class="col-md-12 mt-3">
                        <ul>
                          <li>
                              <strong>
                                <i class="bx bx-map-pin"></i>
                                Địa chỉ:
                              </strong>
                              {{ item.diaChi }}
                          </li>
                          <li>
                              <strong>
                                <i class="bx bx-phone-call"></i>
                                SĐT:
                              </strong>
                              {{ item.sdt }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
          </b-row>
  
  
        </div>
      </div>
    </section>
  </Layout>
</template>


<style>
.view{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
}

.card-img{
    height: 300px;
    padding: 10px 10px 0 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.card-img div img{
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.card-img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.box-text{
    padding: 0px 10px
}

.box-info{
  height: 130px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

/* SILDER MAIN */
.btn-arrow-slider{
  position: absolute;
  top: 50%;
  border: none;
  border-radius: 50%;
}
.btn-left{
  left: 10px;
}
.btn-left-slider{
  left: 20px;
}

.btn-right{
  right: 10px;
}
.slider-main .VueCarousel-pagination{
  position: absolute;
  bottom: 0;
}

.VueCarousel-dot-container{
  margin-top: 0px !important;
}

.VueCarousel-dot-container button{
  margin-top: 0px !important;
}

.VueCarousel-dot--active{
  background-color: #d8266e !important;
}

/* NỘI DUNG */
.content-left{
  min-height: 400px;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
}

.icon-star{
  padding: 15px 0;
  /* border-bottom: 1px solid #1c4a7f; */
}
.icon-stars{
  padding: 5px 0;
}
.icon-stars img{
  width: 25px;
}
.icon-star img{
  width: 25px;
}
.list-star{
  max-height: 400px;
  overflow: scroll;
  overflow-x: hidden;
}
</style>

<style>

.img-null{
  height: 400px;
}
.img-null img{
  height: 100%;
}
.main{
  margin-top: 226px;
}

@media only screen and (max-width: 992px) {
  .main{
    margin-top: 176px;
  }
  .tructiep{
    display: block !important;
  }
}

@media only screen and (max-width: 900px) {
  .main{
    margin-top: 146px;
  }
}

@media only screen and (max-width: 800px) {
  .main{
    margin-top: 126px;
  }
}
@media only screen and (max-width: 700px) {
  .main{
    margin-top: 116px;
  }
}
@media only screen and (max-width: 600px) {
  .main{
    margin-top: 106px;
  }
}
@media only screen and (max-width: 500px) {
  .main{
    margin-top: 86px;
  }
}

.bienban{
  text-align: center;
}
.dropdown-menu.show{
  width: 100% !important;
}
.b-calendar-inner{
  width: 100% !important;
}
.content{
  display: flex;
  justify-content: center;
  max-height: 700px;
}
@media only screen and (max-width: 768px) {
  .content .content-left{
    margin-top: 20px;
    order: 2;
  }
  .content .content-right{
    order: 1;
  }
}
.list-news{
  max-height: 650px;
  /* overflow: scroll;
  overflow-x: hidden; */
}
.list-news:hover a{
  color: #ED0678 !important;
}
.fs-20{
  font-size: 20px;
}

.pd-10{
  padding: 10px;
}

.td-stt {
  width: 50px;
}

.td-content {
  width: 50px;
}

.card{
  margin-bottom: 0px !important;
}

.mt-175{
  margin-top: 175px;
}

.wrap-one{
  padding-top: 20px;
  float: left;
}

/* .wrap-main{
  padding-top: 20px;
} */

.link-pdf{
  margin-top: 5px;
}

.img-kq{
  margin: 10px 0;
}
.img-kq img{
  width: 100%;
}

.card-title-cs{
  padding: 10px;
  color: #fff;
  text-align: center;
  margin: 0;
  text-transform: uppercase;
  font-weight: bold;
}


.border{
  border: 1px solid #ccc !important;
}

.sample-kq img{
  width: 100%;
  height: 300px;
  border-radius: 10px;
}

.sample-kq{
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 5px;
  min-height: 300px;
}

.card-title-news{
  text-align: center;
}

.news{
  padding: 10px;
}

.block-post{
  text-align: justify;
}

.block-left{
  border-right: 1px solid #ccc;
}

.lib-img img{
  border-radius: 10px;
  width: 100%;
}
.lib-img{
  display: flex;
  justify-content: center;

}


.lib img{
	transform: scale(1);
	transition: .3s ease-in-out;
}

.lib:hover img{
  -webkit-transform: scale(1.1);
	transform: scale(1.1);
  opacity: 0.7;
}

.decs{
  position: absolute;
  color: #fff;
  font-size: 13px;
  display: flex;
  font-weight: bold;
  top:-25px;
}

.decs p{
  padding: 5px;
  text-align: center;
  transform: translateY(40px);
	transition: 0.5s;
	opacity: 0;
  z-index: 1;
  background-color: #05912a;
  border-radius: 5px;
}
.lib:hover .decs p{
  transform: translateY(0px);
	opacity: 1;
}


.title-search{
  width: 100%;
  text-align: center;
}

.title-search h3{
  color: #ec232b;
}

/* CARD */
article {
  --img-scale: 1.001;
  --title-color: black;
  --link-icon-translate: -20px;
  --link-icon-opacity: 0;
  position: relative;
  border-radius: 16px;
  box-shadow: none;
  background: #fff;
  transform-origin: center;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

article a::after {
  position: absolute;
  inset-block: 0;
  inset-inline: 0;
  cursor: pointer;
  content: "";
}

/* basic article elements styling */
article h2 {
  margin: 0 0 18px 0;
  font-family: "Bebas Neue", cursive;
  font-size: 1.9rem;
  letter-spacing: 0.06em;
  color: var(--title-color);
  transition: color 0.3s ease-out;
}

figure {
  margin: 0;
  padding: 0;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

article img {
  max-width: 100%;
  transform-origin: center;
  transform: scale(var(--img-scale));
  transition: transform 0.4s ease-in-out;
}

.article-body {
  padding: 20px;
}

article a {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #28666e;
}

article a:focus {
  outline: 1px dotted #28666e;
}

article a .icon {
  min-width: 24px;
  width: 24px;
  height: 24px;
  margin-left: 5px;
  transform: translateX(var(--link-icon-translate));
  opacity: var(--link-icon-opacity);
  transition: all 0.3s;
}

/* using the has() relational pseudo selector to update our custom properties */
article:has(:hover, :focus) {
  --img-scale: 1.1;
  --title-color: #28666e;
  --link-icon-translate: 0;
  --link-icon-opacity: 1;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}


/************************
Generic layout (demo looks)
**************************/

*,
*::before,
*::after {
  box-sizing: border-box;
}
/* .articles {
  display: grid;
  max-width: 1200px;
  margin-inline: auto;
  padding-inline: 24px;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
} */

@media screen and (max-width: 992px) {
  article {
    container: card/inline-size;
    margin-bottom: 10px;
  }
  .article-body h2 {
    font-size: 18px !important;
  }
  .list-tin{
    display: none !important;
  }
}

@media screen and (min-width: 768px) {
  .content{
    height: 100% !important;
  }
}

@media screen and (max-width: 768px) {
  .content{
    max-height: 100% !important;
  }
  .video-sub{
    height: 300px !important;
  }
  .video-sub iframe{
    height: 100%;
  }
  #carousel-1 .carousel-inner{
    height: 700px !important;
  }
}

/* @media screen and (max-width: 960px) {
  article {
    container: card/inline-size;
  }
  .article-body p {
    display: none;
  }
} */


@container card (min-width: 380px) {
  .article-wrapper {
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 16px;
  }
  .article-body {
    padding-left: 0;
  }
  figure {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  figure img {
    height: 100%;
    aspect-ratio: 1;
    object-fit: cover;
  }
}

.sr-only:not(:focus):not(:active) {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.img-lienket img{
  width: 100%;
  height: 150px;
}

.img-tintuc{
  border-radius: 20px !important;
}

.title-news{
  display: flex;
  align-items: center;
}

.title-news a p{
  margin-bottom: 0px;
  text-align: justify;
}
.news-title{
  text-align: justify;
}

.card-noti{
  height: 379px;
  overflow: scroll;
  overflow-x: hidden !important;
}

.cate-list-noti{
  padding: 10px;
}

.cate-list-noti ul li{
  list-style: none;
  padding: 10px 0 10px 0;
}

@media (max-width: 768px){
    .lib{
      margin-bottom: 10px;
    }
}

#carousel-1 .carousel-inner {
  height: 650px;
}
#carousel-1 .carousel-caption {
  bottom:-200px
}
#carousel-1 .carousel-inner img {
  object-fit: cover;
}
.carousel-control-next, .carousel-control-prev{
  height: 450px;
}
@media screen and (max-width: 576px) {

  .card-map{
    padding: 0 20px;
  }

  #carousel-1 .carousel-inner{
    height: 600px !important;
  }
  .carousel-control-next, .carousel-control-prev{
    height: 350px;
  }
}
@media screen and (max-width: 430px) {

  #carousel-1 .carousel-inner{
    height: 450px !important;
  }
}
.carousel-item{
  position: absolute !important;
}

.carousel-caption{
  position:sticky;
  left: 0 !important;
  right: 0 !important;
}

.option{
  border-radius: 0 !important;
}


/*************MÓN ĂN TỪ SEN ***************/
.img-food{
  border-radius: 20px;
}
.img-food img{
  width: 100%;
  border-radius: 20px;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  max-height: 500px;
}

.img-dl{
  border-radius: 20px;
}
.img-dl img{
  width: 100%;
  border-radius: 20px;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  max-height: 500px;
}

.img-dl div{
  position: relative;
}

.img-food-sub{
  border-radius: 20px;
  position: relative;
}

.img-food-sub img{
  width: 100%;
  border-radius: inherit;
  aspect-ratio: 3 / 2;
  object-fit: cover;
}

.food-lotus .VueCarousel-slide{
  padding: 0px 10px 10px 10px;
}

.btn-arrow-left-food{
  position: absolute;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  backdrop-filter: blur(2px);
  box-shadow: 0px 0px 3px #cacaca;
  top: 45%;
  left: 0px;
  transform: translateY(-50%);
  margin: 0;
  transition: all .5s ease;
  outline: none;
  border: 1px solid #ccc;
}

.btn-arrow-right-food{
  position: absolute;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  backdrop-filter: blur(2px);
  box-shadow: 0px 0px 3px #cacaca;
  top: 45%;
  right: 0px;
  transform: translateY(-50%);
  margin: 0;
  transition: all .5s ease;
  outline: none;
  border: 1px solid #ccc;
}
.food-lotus .VueCarousel-pagination{
  display: none;
}

/***********************DU LỊCH SEN*************/
.card-bg{
  background-color: #f85497;
  position: relative;
  height: 150px;
  border-radius: 20px;
  margin: 20px;
}
.card-dn{
  position: absolute;
  background-color: #f2f2f2;
  border-radius: 10% 13% 0% 34% / 0% 34% 20% 60%;
  padding: 25px;
  right: -20px;
  top: -20px;
  width: 100%;
  height: 150px;
  /* box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 17%) !important */
}

.card-addres{
  position: absolute;
  right: 20px;
  bottom: 0;
}

.name-dn, .add-dn, .sdt-dn{
  text-align: right;
  color: #000;
}


/************************CSS NAME CARD **********************/
.card-name{
  color: #537961; 
  text-align: center;
  font-weight: bold;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 !important;
  font-size: clamp(0.8125rem, 0.6786rem + 0.4286vw, 1rem);
}
.card-name-dl{
  position: absolute;
  left: 10px;
  bottom: 0;
  padding: 5px;
  border-radius: 5px;
  background-color: #05912abd;
  color: #fff; 
  font-weight: bold;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 !important;
  font-size: clamp(0.8125rem, 0.6786rem + 0.4286vw, 1rem);
}

.card-name-dl-sub{
  position: absolute;
  left: 10px;
  bottom: 0;
  padding: 3px;
  border-radius: 5px;
  background-color: #05912abd;
  color: #fff; 
  font-weight: bold;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 !important;
  font-size: clamp(0.625rem, 0.4911rem + 0.4286vw, 0.8125rem);
}

.card-name-sub{
  color: #000; 
  text-align: center;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 !important;
  font-size: clamp(0.8125rem, 0.7679rem + 0.1429vw, 0.875rem);
  text-align: justify;
}

.card-name-sen{
  position: absolute;
  background-color: rgba(216,38,110,.7);
  padding: 5px;
  color: #fff;
  margin: 0;
  top: 269px;
  left: 30px;
  text-transform: uppercase;
  border-radius: 5px;
  font-size: clamp(0.8125rem, 0.7679rem + 0.1429vw, 0.875rem);
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/************************** */
.bg-left{
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-left img{
  width: 90%;
}

.bg-right{

}

.bg-right .card-doanhnghiep-name{
  text-transform: uppercase;
  color: #05912a;
  font-weight: bold;
  font-size: clamp(0.625rem, 0.4911rem + 0.4286vw, 0.8125rem);
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bg-right .card-doanhnghiep-daidien{
  text-transform: uppercase;
  color: #05912a;
  font-weight: bold;
  font-size: clamp(0.625rem, 0.4911rem + 0.4286vw, 0.8125rem);
  border-bottom: 1px solid #000;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}

.bg-right span{
  text-transform: uppercase;
  color: #000;
  font-size: 10px;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-doanhnghiep{
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 5%) !important;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  height: 200px;
  cursor: pointer;
  margin: 10px;
}
.card-doanhnghiep ul{
  padding-left: 10px !important;
}

.card-doanhnghiep ul li{
  list-style: none;
  font-size: clamp(0.625rem, 0.5357rem + 0.2857vw, 0.75rem);
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media only screen and (max-width: 768px) {
  .bg-left img {
    width: 55%;
  }
}

@media only screen and (max-width: 576px) {
  .bg-left{
    width: 33%;
  }
  .bg-right{
    width: 66%;
  }
  .bg-left img {
    width: 100%;
  }
}


/*****************PHÂN TRANG ***************************/

/*****************PHÂN TRANG SẢN PHẨM SEN ***************************/
.col-pagination{
  position: absolute;
  top: 50%;
}

#pagination-sps{
  width: 100%;
}
#pagination-sps ul{
  width: 100%;
  display: flex;
  position: relative;
}

#pagination-sps .page-item:nth-child(2) .page-link, #pagination-sps .page-item:nth-last-child(2) .page-link{
  background-color: #05912a;
  cursor: pointer;
  color: #fff;
  font-size: 25px;
  line-height: 30px;
}

#pagination-sps .page-item:nth-child(2){
  position: absolute;
  left: -30px;
}
#pagination-sps .page-item:nth-last-child(2){
  position: absolute;
  right: -30px;
}
#pagination-sps .page-item:not(:nth-child(2)):not(:nth-last-child(2)) {
  display: none;
}

@media only screen and (max-width: 768px) {
  .col-pagination{
    top: 0;
  }
  #pagination-sps ul{
    justify-content: flex-end;
    margin-top: 10px;
  }
  #pagination-sps .page-item:nth-child(2){
    position: relative;
    left: 0;
  }
  #pagination-sps .page-item:nth-last-child(2){
    position: relative;
    right: 0;
  }
}

/*****************PHÂN TRANG DU LỊCH SEN***************************/

#pagination-dl{
  width: 100%;
}
#pagination-dl ul{
  width: 100%;
  display: flex;
  position: relative;
}

#pagination-dl .page-item:nth-child(2) .page-link, #pagination-dl .page-item:nth-last-child(2) .page-link{
  background-color: #05912a;
  cursor: pointer;
  color: #fff;
  font-size: 25px;
  line-height: 30px !important;
}

#pagination-dl .page-item:nth-child(2){
  position: absolute;
  left: -30px;
}
#pagination-dl .page-item:nth-last-child(2){
  position: absolute;
  right: -30px;
}
#pagination-dl .page-item:not(:nth-child(2)):not(:nth-last-child(2)) {
  display: none;
}

@media only screen and (max-width: 768px) {
  .col-pagination{
    top: 0;
  }
  #pagination-dl ul{
    justify-content: flex-end;
    margin-top: 10px;
  }
  #pagination-dl .page-item:nth-child(2){
    position: relative;
    left: 0;
  }
  #pagination-dl .page-item:nth-last-child(2){
    position: relative;
    right: 0;
  }
}

/*****************PHÂN TRANG SEN***************************/
.col-sen{
  position: absolute;
  top: 30px;
}

#pagination-sen{
  width: 100%;
}
#pagination-sen ul{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

#pagination-sen .page-item:nth-child(2) .page-link, #pagination-sen .page-item:nth-last-child(2) .page-link{
  background-color: #05912a;
  cursor: pointer;
  color: #fff;
  font-size: 25px;
  line-height: 30px !important;
}

#pagination-sen .page-item:not(:nth-child(2)):not(:nth-last-child(2)) {
  display: none;
}

@media only screen and (max-width: 768px) {
  .col-sen{
    top: 10px;
  }
  #pagination-sen ul{
    justify-content: flex-end;
    margin-top: 10px;
  }
  #pagination-sen .page-item:nth-child(2){
    position: relative;
    left: 0;
  }
  #pagination-sen .page-item:nth-last-child(2){
    position: relative;
    right: 0;
  }
}

/*****************PHÂN TRANG MÓN ĂN SEN***************************/

#pagination-monan{
  width: 100%;
}
#pagination-monan ul{
  width: 100%;
  display: flex;
  position: relative;
}

#pagination-monan .page-item:nth-child(2) .page-link, #pagination-monan .page-item:nth-last-child(2) .page-link{
  background-color: #05912a;
  cursor: pointer;
  color: #fff;
  font-size: 25px;
  line-height: 30px !important;
}

#pagination-monan .page-item:nth-child(2){
  position: absolute;
  left: -30px;
}
#pagination-monan .page-item:nth-last-child(2){
  position: absolute;
  right: -30px;
}
#pagination-monan .page-item:not(:nth-child(2)):not(:nth-last-child(2)) {
  display: none;
}

@media only screen and (max-width: 768px) {
  .col-pagination{
    top: 0;
  }
  #pagination-monan ul{
    justify-content: flex-end;
    margin-top: 10px;
  }
  #pagination-monan .page-item:nth-child(2){
    position: relative;
    left: 0;
  }
  #pagination-monan .page-item:nth-last-child(2){
    position: relative;
    right: 0;
  }
}


/***************** TIN TỨC NỔI BẬT ************************/
.card-new-left{
  border-radius: 20px;
}
.card-new-left img{
  width: 100%;
  border-radius: 20px;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  max-height: 500px;
}
.card-new{
  background-color: #fff;
  padding: 30px;
  border-radius: 35px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.card-new .img-new{
  
}

.card-new-name{
  color: #537961; 
  text-align: center;
  font-weight: bold;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0 !important;
  font-size: clamp(0.8125rem, 0.6786rem + 0.4286vw, 1rem);
}

.card-new-name-sub{
  color: #000; 
  text-align: center;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0px !important;
  font-size: clamp(0.8125rem, 0.7679rem + 0.1429vw, 0.875rem);
  text-align: justify;
}

.img-new-right img{
  width: 100%;
  border-radius: 15px;
  aspect-ratio: 3 / 2;
  object-fit: cover;
}

.card-new-name-title{
  color: #537961; 
  font-weight: bold;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0 !important;
  font-size: clamp(0.8125rem, 0.6786rem + 0.4286vw, 1rem);
}
</style>

